import { callApi } from './ApiClient';

const postAddressCorporationDifferencesVerify = (data, dispatch) => {
  return callApi('POST', `/address-corporation-differences/verify`, data, dispatch);
}

const getAddressCorporationDifferencesCount = (dispatch) => {
  return callApi('GET', `/address-corporation-differences/count`, null, dispatch);
}

const postAddressCorporationDifferencesUpdateDifference = (data, dispatch) => {
  return callApi('POST', `/address-corporation-differences/update-difference`, data, dispatch);
}

export const AddressCorporationDifferencesApi = {
  postAddressCorporationDifferencesVerify,
  getAddressCorporationDifferencesCount,
  postAddressCorporationDifferencesUpdateDifference,
};



// WEBPACK FOOTER //
// ./src/redux/api/AddressCorporationDifferencesApi.js